import { Icon, type IconName } from '@smartech/ui';
import BgWave from '../../../assets/img/empty-state-bg-wave.svg?react';

interface CustomEmptyStateProps {
  icon: IconName;
  title: string;
  description?: string | React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const CustomEmptyState: React.FC<CustomEmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div
      className={`relative flex h-full min-h-[440px] flex-col items-center justify-center overflow-hidden px-8 py-16 ${className}`}
    >
      <BgWave className="absolute top-0 min-h-[480px] min-w-[480px]" />
      <div className={`absolute top-[215px] z-10 flex flex-col items-center text-center`}>
        <div className="flex rounded-xl border border-icons-modern-border bg-primary p-xl shadow-skeuomorphic-inner">
          <Icon name={icon} className="text-2xl text-gray-500" />
        </div>

        <h3 className="mt-5xl text-xl font-semibold text-gray-900">{title}</h3>

        {description && (
          <div className="mb-8xl mt-md max-w-md text-sm text-gray-600">{description}</div>
        )}

        {action && <div className="pt-2">{action}</div>}
      </div>
    </div>
  );
};

export default CustomEmptyState;
